import React, { useState } from 'react';
import { Modal, Button, Image, Carousel } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import './dayPlan.css';

export const ModalShowImages = ({ show, onHide, dataList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? dataList.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === dataList.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="image-carousel-modal"
      centered
      fullscreen
    >
      <Modal.Header className="border-0">
        <Button 
          variant="link" 
          className="close-button" 
          onClick={onHide}
        >
          <FaTimes size={24} />
        </Button>
      </Modal.Header>
      
      <Modal.Body className="d-flex align-items-center justify-content-center position-relative">
        {dataList && dataList.length > 0 && (
          <>
            <Button
              variant="link"
              className="carousel-control prev-button"
              onClick={handlePrevious}
            >
              <FaChevronLeft size={40} />
            </Button>

            <div className="image-container">
             <img
  src={dataList[currentIndex]}
  alt={`Image ${currentIndex + 1}`}
  style={{ 
    maxWidth: "100%",
    maxHeight: "90vh", 
    objectFit: "contain" 
  }}
/>
            </div>

            <Button
              variant="link"
              className="carousel-control next-button"
              onClick={handleNext}
            >
              <FaChevronRight size={40} />
            </Button>

            <div className="image-counter">
              {currentIndex + 1} / {dataList.length}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

const ModalShowVideos = ({ show, onHide, dataList }) => {
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];

  const getEmbedData = (url) => {
    if (!url) return null;

    const lowerUrl = url.toLowerCase();

    // 1. YouTube
    if (url.includes('youtu.be')) {
      const videoId = url.split('/').pop().split('?')[0];
      return { type: 'iframe', url: `https://www.youtube.com/embed/${videoId}` };
    }

    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('watch?v=')[1].split('&')[0];
      return { type: 'iframe', url: `https://www.youtube.com/embed/${videoId}` };
    }

    // 2. Vimeo
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
      return { type: 'iframe', url: `https://player.vimeo.com/video/${vimeoMatch[1]}` };
    }

    // 3. Direct video file (mp4, webm, etc.)
    if (videoExtensions.some(ext => lowerUrl.endsWith(ext))) {
      return { type: 'video', url };
    }

    // 4. Unknown platform – fallback to iframe
    return { type: 'iframe', url };
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Video Gallery</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          {dataList && dataList.length > 0 ? (
            dataList.map((videoUrl, index) => {
              const embedData = getEmbedData(videoUrl);
              if (!embedData) return null;

              return (
                <div key={index}>
                  {embedData.type === 'iframe' ? (
                    <iframe
                      width="100%"
                      height="360"
                      src={embedData.url}
                      title={`video-${index}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}
                    ></iframe>
                  ) : (
                    <video
                      width="100%"
                      height="360"
                      controls
                      controlsList="nodownload"
                      style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}
                    >
                      <source src={embedData.url} />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              );
            })
          ) : (
            <p className="text-center">No Videos to display</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { ModalShowVideos };
